export class ProfessionalLeadService {

  getDetails = (id: string): Promise<any> => {
    const query = `/tools/exportables/professional_leads/${id}`
    return this.makeFetchCall(query)
  }

  /**
   * Given a query, make a fetch call, and try to return a response.
   * @type {Promise<any>}
   */
  private makeFetchCall: Function = async (query): Promise<any> => {
    try {
      const response: Response = await fetch(query)
      if (response.ok) {
        return response.json()
      } else {
        return Promise.reject(response.json())
      }
    } catch (e: unknown) {
      return Promise.reject(e)
    }
  }

}